<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="600" persistent>
        <v-card>
          <v-card-title class="text-h5 blue darken-3 white--text">
            Seleccione la fecha de campaña
          </v-card-title>
  
          <v-card-text>  
            <p class="text-center purple--text mt-8 mb-0">Ingrese la fecha tentativa de inicio de campaña, el sistema le asignara la fecha final segun el tipo de proyecto </p>
            <p class="text-center mt-0"> {{ proy.nombre_proyecto }} </p>
            <div class="row justify-center">  
              <div class="col-xs-12 col-sm-6">
                <v-text-field label="Fecha inicio de campaña:" v-model="input.fecha_inicio"  type="date" prefix="desde:" hide-details @input="setlimite" />
              </div> 
            </div> 

            <!-- estas fechas no les interesa a ESAM -->
            <p v-show="unidad_id!=1" class="mt-8 mb-0 green--text">Periodo de creacion del programa en el portal ESAM (debe crear el programa antes del inicio de campaña):</p>
            <div v-show="unidad_id!=1" class="row justify-center">  
              <div class="col-xs-12 col-sm-6">
                <v-text-field label="Fecha inicio de creacion prog:" v-model="input.fecha_inicio_prog"  type="date" prefix="desde:" hide-details />
              </div> 
              <div class="col-xs-12 col-sm-6">
                <v-text-field label="Fecha limite de creacion prog:" v-model="input.fecha_limite_prog"  type="date" prefix="limite:" hide-details />
              </div> 
            </div> 

            <p class="mt-7">
              Esta informacion se enviara al academico nacional de proyectos para su posterior aprobacion y habilitacion de la opcion de crear programa. Es crucial que las fechas propuestas sean viables para garantizar un proceso sin inconvenientes. 
            </p>
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" outlined @click="enviar()"> Realizar solicitud </v-btn>
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>

export default {
    data() {
        return { 
            dialog: false,
            input: {},
            proy:{},
            resolvePromise: null,
            unidad_id: null,
        };
    },
    methods: {
        async openmodal(p) { 
          this.proy = p
            this.input = {
              fecha_inicio: null,
              fecha_inicio_prog: null,
              fecha_limite_prog: null,
            };
            this.dialog = true;
            this.hoy();

            this.unidad_id = this.$store.state.CARGO.sede.unidad_negocio
            return new Promise((resolve) => {
                this.resolvePromise = resolve;
            });
        },
        hoy(){
          const fechaActual = new Date(); 
          const año = fechaActual.getFullYear();
          const mes = String(fechaActual.getMonth() + 1).padStart(2, '0'); 
          const dia = String(fechaActual.getDate()).padStart(2, '0'); 
          const fechaFormateada = `${año}-${mes}-${dia}`;
          this.input.fecha_inicio_prog = fechaFormateada;
        },
        setlimite(){ 
          this.input.fecha_limite_prog = this.input.fecha_inicio;
        },

        cerrar(){
          this.resolvePromise(false);
          this.dialog = false;
        },
        enviar(){
            let msg = ''
            if(!this.input.fecha_limite_prog) msg = 'ingrese la fecha limite reg programa'
            if(!this.input.fecha_inicio_prog) msg = 'ingrese la fecha inicio reg programa'
            if(!this.input.fecha_inicio) msg = 'ingrese la fecha inicio'
            if(msg){
                this.$root.$notify.show(msg, {color:'red',x: 'right',})
                return
            }

            const u = {...this.input}
            u.fecha_inicio += 'T00:00:00-04:00'
            u.fecha_inicio_prog += 'T00:00:00-04:00'
            u.fecha_limite_prog += 'T00:00:00-04:00'

            this.resolvePromise(u);
            this.dialog = false;
        }
    }
};
</script>
  